export default {
  queryCsPunishList: '/gateway/capp/courier_operations/queryCsPunishList'
}
